import React from "react";
const HiddenInput = ({ value }) => {
    return React.createElement("input", { type: "hidden", value: value });
};
export default HiddenInput;
